import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ChangePassword from "./pages/ChangePassword";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard"; // Assuming you have a Dashboard component
import ViewBookingList from "./pages/ViewBookingList";
import GuestHouseDetail from "./pages/GuestHouseDetail";
import ResetPassword from "./pages/ResetPassword";
import BookingSuccess from "./pages/BookingSuccess";
import authService from "./services/authService";
import { useEffect, useState } from "react";

function App() {
   const [encryptionReady, setEncryptionReady] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Initialize encryption on app startup
    const initializeApp = async () => {
      try {
        const isReady = await authService.initializeEncryption();
        setEncryptionReady(isReady);
      } catch (error) {
        console.error('App initialization failed:', error);
      } finally {
        setLoading(false);
      }
    };

    initializeApp();
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/booking/success" element={<BookingSuccess />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          {/* <Route path="/reset-password" element={<ResetPassword />} /> */}

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
          
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/viewbookings" element={<ViewBookingList />} />
            <Route path="/reports/property-wise" element={<ViewBookingList />} />
            <Route path="/reports/employee-wise" element={<ViewBookingList />} />
            <Route path="/guest-house/:id" element={<GuestHouseDetail />} />
            {/* Add other protected routes here */}
          </Route>

          {/* Redirect any other route to the login page */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
